import { Barras } from "./Barras.tsx";

/** Cabecera de página: overline con las tres barras, título en Archivo y acciones a la derecha. */
export function Encabezado({
  overline,
  titulo,
  acciones,
}: {
  overline: string;
  titulo: string;
  acciones?: React.ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
      <div>
        <div className="mb-1 flex items-center gap-2 text-rojo-marca">
          <Barras alto={10} />
          <span className="font-display text-[11px] font-semibold tracking-[.14em] text-texto-3 uppercase">
            {overline}
          </span>
        </div>
        <h1 className="text-[26px] font-bold text-marino">{titulo}</h1>
      </div>
      {acciones && <div className="flex flex-wrap gap-2 pt-4">{acciones}</div>}
    </div>
  );
}

/** Tarjeta de KPI del mockup, con las barras como remate cuando el valor pide atención. */
export function Kpi({
  valor,
  etiqueta,
  tono = "marino",
}: {
  valor: number | string;
  etiqueta: string;
  tono?: "marino" | "verde" | "ambar" | "rojo";
}) {
  const colorValor = {
    marino: "text-marino",
    verde: "text-verde",
    ambar: "text-ambar",
    rojo: "text-rojo",
  }[tono];
  return (
    <div className="relative overflow-hidden rounded-tarjeta border border-borde bg-white px-4 py-3.5">
      <div className={`font-display text-[26px] font-bold ${colorValor}`}>{valor}</div>
      <div className="text-[12px] font-semibold text-texto-3">{etiqueta}</div>
      <div className="absolute -right-1 bottom-2 text-borde">
        <Barras alto={18} />
      </div>
    </div>
  );
}
